import { render, staticRenderFns } from "./mobile-header.vue?vue&type=template&id=2cc0faae&scoped=true&"
import script from "./mobile-header.vue?vue&type=script&lang=js&"
export * from "./mobile-header.vue?vue&type=script&lang=js&"
import style0 from "./mobile-header.vue?vue&type=style&index=0&id=2cc0faae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc0faae",
  null
  
)

export default component.exports